import type { LDFlagSet } from 'launchdarkly-js-sdk-common';

import {
  FF_AWAITING_DOCUMENT_DOCTOR_CONSULT_STATUS,
  FF_BOOK_ANY_DOCTOR_IF_CURRENT_DOCTOR_INACTIVE,
  FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT,
  FF_C4C_HIDE_PATIENT_PHONE_NUMBER,
  FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2,
  FF_C4C_RECORD_VOICE_CALL,
  FF_C4C_VIDEO_CONSULT,
  FF_C4C_VOICE_CALL,
  FF_CALCOM_EMBED_PARAMS,
  FF_CONCESSION_DISCOUNT_RATE,
  FF_CONSULTATION_BOOKING_PAYMENT_WINDOW,
  FF_CONSULTATION_FOLLOW_UP_PRICE,
  FF_CONSULTATION_PRICE_JSON,
  FF_DISABLE_CALCOM_FOLLOWUP_ROUND_ROBIN_MANAGEMENT,
  FF_DOCTOR_ONBOARDING_CLINIC_SELECTION,
  FF_ENABLE_CANCEL_INSTANT_CONSULTATION,
  FF_ENABLE_DISCOUNT_CODES,
  FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE,
  FF_ENABLE_INITIAL_DR_PAYMENT,
  FF_ENABLE_PMS_ERROR_HANDLING,
  FF_ENABLE_SHOPIFY_PAYMENT,
  FF_ENABLE_SNOWPLOW,
  FF_FLOWER_DISPENSE_LIMIT_V2,
  FF_GDC_RELEASE_1,
  FF_IMMUTABLE_CLINIC_NOTES,
  FF_INVENTORY_INSIGHTS_ENFORCE_GREENA_REPEATS,
  FF_NURSE_INSTANT_CONSULTATION,
  FF_PAT_ENABLE_DEVICE_PRESCRIPTION,
  FF_PAT_PREFILL_DOSAGE,
  FF_PAT_PRESCRIPTION_DOSAGE_MIN_LENGTH_VALIDATION,
  FF_PATIENT_CENTRIC_FOLLOWUPS,
  FF_PATIENT_PAGE_AUTOSAVE_TOUR,
  FF_PATIENT_V2_SAVE_ONLY_CHANGED_FIELDS,
  FF_PRESCRIPTION_RECOMMENDED_INFO,
  FF_PRESCRIPTION_RECOMMENDED_PRODUCTS_COUNT,
  FF_PRESCRIPTION_TAB_REDESIGN,
  FF_SCHEDULED_CONSULT_TOUR,
  FF_SHOW_PATIENT_STUDY_ALERT,
  FF_TREATMENT_CONSENT_FORM_CONTENT_UPDATE,
  FF_UNSAVED_CONSULTATION_CHANGES_PROMPT,
  FF_WOMBATS_DEVICE_TESTING,
} from '@/constants/featureFlags';

const ffDefaults: LDFlagSet = {
  [FF_CONSULTATION_PRICE_JSON]: { displayPrice: '29', chargePrice: '29' },
  [FF_CONSULTATION_FOLLOW_UP_PRICE]: '29',
  [FF_CONCESSION_DISCOUNT_RATE]: 0,
  [FF_ENABLE_DISCOUNT_CODES]: false,
  [FF_ENABLE_SNOWPLOW]: false,
  [FF_PRESCRIPTION_RECOMMENDED_PRODUCTS_COUNT]: 3,
  [FF_PRESCRIPTION_RECOMMENDED_INFO]:
    '{"href": "https://app.getguru.com/card/iByRzd4T/Prescription-assistant-guide","text": "Product recommendations are based on your selections and availability criteria"}',
  [FF_CONSULTATION_BOOKING_PAYMENT_WINDOW]: 600,
  [FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE]: false,
  [FF_INVENTORY_INSIGHTS_ENFORCE_GREENA_REPEATS]: false,
  [FF_IMMUTABLE_CLINIC_NOTES]: false,
  [FF_ENABLE_PMS_ERROR_HANDLING]: false,
  [FF_BOOK_ANY_DOCTOR_IF_CURRENT_DOCTOR_INACTIVE]: false,
  [FF_PAT_PRESCRIPTION_DOSAGE_MIN_LENGTH_VALIDATION]: false,
  [FF_C4C_VOICE_CALL]: true,
  [FF_C4C_RECORD_VOICE_CALL]: false,
  [FF_C4C_VIDEO_CONSULT]: false,
  [FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT]: false,
  [FF_PAT_ENABLE_DEVICE_PRESCRIPTION]: false,
  [FF_NURSE_INSTANT_CONSULTATION]: false,
  [FF_CALCOM_EMBED_PARAMS]: false,
  [FF_C4C_HIDE_PATIENT_PHONE_NUMBER]: false,
  [FF_PATIENT_V2_SAVE_ONLY_CHANGED_FIELDS]: false,
  [FF_DISABLE_CALCOM_FOLLOWUP_ROUND_ROBIN_MANAGEMENT]: false,
  [FF_ENABLE_CANCEL_INSTANT_CONSULTATION]: false,
  [FF_SHOW_PATIENT_STUDY_ALERT]: false,
  [FF_PAT_PREFILL_DOSAGE]: false,
  [FF_PATIENT_PAGE_AUTOSAVE_TOUR]: false,
  [FF_PATIENT_CENTRIC_FOLLOWUPS]: false,
  [FF_ENABLE_SHOPIFY_PAYMENT]: false,
  [FF_PRESCRIPTION_TAB_REDESIGN]: true,
  [FF_GDC_RELEASE_1]: false,
  [FF_DOCTOR_ONBOARDING_CLINIC_SELECTION]: false,
  [FF_AWAITING_DOCUMENT_DOCTOR_CONSULT_STATUS]: false,
  [FF_FLOWER_DISPENSE_LIMIT_V2]: false,
  [FF_ENABLE_INITIAL_DR_PAYMENT]: false,
  [FF_UNSAVED_CONSULTATION_CHANGES_PROMPT]: false,
  [FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2]: false,
  [FF_WOMBATS_DEVICE_TESTING]: false,
  [FF_TREATMENT_CONSENT_FORM_CONTENT_UPDATE]: false,
  [FF_SCHEDULED_CONSULT_TOUR]: false,
};

export default ffDefaults;
